<template>
  <div class="hello">
    <b-navbar type="light" variant="light">
      <b-navbar-brand>
        <!-- HOW TOO NAV UP TWO DIRECTORIES https://css-tricks.com/quick-reminder-about-file-paths/-->
        <img
          src="../../assets/logo.png"
          height="40"
          width="40"
          class="d-inline-block align-top"
          alt="Kitten"
        >
      </b-navbar-brand>
      <b-navbar-nav class = "ml-auto">
        <b-button  variant="success" :to = "{name:'month-picker'}" class="mr-3">I'm not here!  Sign Me In</b-button>
        <b-button  variant="success" class="mr-3">Guests Sign In Here</b-button>
        <b-button  variant="success" :to = "{name:'login'}" class="mr-3">Close</b-button>
      </b-navbar-nav>
    </b-navbar>
      
  </div>
</template>

<script>
export default {
  
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
